/**
 * Shape of the RTK Query rejected-action payload we care about: the HTTP status
 * plus the parsed JSON body (backend returns `{ code, message }`).
 */
export interface RejectedPayload {
  status?: number;
  data?: { code?: string };
}

/**
 * True when a rejected request is the backend's "property dispositioned" signal:
 * HTTP 403 with body `{ code: 'PROPERTY_INACTIVE' }`. Emitted by resident-portal-api
 * for residents whose leases are all on deactivated properties. Kept pure so the
 * decision is unit-testable independent of the store middleware side effects.
 */
export const PROPERTY_INACTIVE_CODE = "PROPERTY_INACTIVE";

export function isPropertyInactivePayload(
  payload: RejectedPayload | undefined
): boolean {
  return payload?.status === 403 && payload?.data?.code === PROPERTY_INACTIVE_CODE;
}
